// src/features/dashboard/components/ManagerDashboard/AtRiskAssociate/AtRiskFilters.tsx

import {
  Search,
  RotateCcw,
} from 'lucide-react';


type Props = {
  teams: string[];
  riskLevels: string[];
  statuses: string[];
  shifts: string[];
  locations: string[];

  selectedTeam: string;
  selectedRiskLevel: string;
  selectedStatus: string;
  selectedShift: string;
  selectedLocation: string;
  searchTerm: string;

  onTeamChange: (
    value: string,
  ) => void;

  onRiskLevelChange: (
    value: string,
  ) => void;

  onStatusChange: (
    value: string,
  ) => void;

  onShiftChange: (
    value: string,
  ) => void;

  onLocationChange: (
    value: string,
  ) => void;

  onSearchChange: (
    value: string,
  ) => void;

  onReset: () => void;
};


const selectClassName = `
  h-11
  rounded-xl
  border
  border-slate-200
  bg-white
  px-3
  text-sm
  text-slate-700
  outline-none
  transition
  focus:border-blue-500
  focus:ring-1
  focus:ring-blue-500
`;


const AtRiskFilters = ({
  teams,
  riskLevels,
  statuses,

  selectedTeam,
  selectedRiskLevel,
  selectedStatus,
  searchTerm,

  onTeamChange,
  onRiskLevelChange,
  onStatusChange,
  onSearchChange,

  onReset,
}: Props) => {

  return (
    <div
      className="
        mt-5
        rounded-2xl
        border
        border-slate-200
        bg-white
        p-4
      "
    >

      <div
        className="
          flex
          flex-wrap
          items-center
          gap-3
        "
      >

        {/* =========================================
            TEAM
        ========================================== */}

        <select
          value={selectedTeam}
          onChange={(e) =>
            onTeamChange(
              e.target.value,
            )
          }
          className={`${selectClassName} w-[180px]`}
        >

          <option value="">
            All Teams
          </option>

          {teams.map(
            (team) => (
              <option
                key={team}
                value={team}
              >
                {team}
              </option>
            ),
          )}

        </select>


        {/* =========================================
            SEARCH
        ========================================== */}

        <div
          className="
            flex
            h-11
            w-[280px]
            items-center
            gap-2
            rounded-xl
            border
            border-slate-200
            px-3
            transition
            focus-within:border-blue-500
            focus-within:ring-1
            focus-within:ring-blue-500
          "
        >

          <Search
            size={16}
            className="
              shrink-0
              text-slate-400
            "
          />

          <input
            type="text"
            value={searchTerm}
            onChange={(e) =>
              onSearchChange(
                e.target.value,
              )
            }
            placeholder="Search associate..."
            className="
              min-w-0
              flex-1
              bg-transparent
              text-sm
              text-slate-700
              outline-none
              placeholder:text-slate-400
            "
          />

        </div>


        {/* =========================================
            RISK LEVEL
        ========================================== */}

        <select
          value={
            selectedRiskLevel
          }
          onChange={(e) =>
            onRiskLevelChange(
              e.target.value,
            )
          }
          className={`${selectClassName} w-[150px]`}
        >

          <option value="">
            Risk Level
          </option>

          {riskLevels.map(
            (risk) => (
              <option
                key={risk}
                value={risk}
              >
                {risk}
              </option>
            ),
          )}

        </select>


        {/* =========================================
            STATUS
        ========================================== */}

        <select
          value={
            selectedStatus
          }
          onChange={(e) =>
            onStatusChange(
              e.target.value,
            )
          }
          className={`${selectClassName} w-[150px]`}
        >

          <option value="">
            Status
          </option>

          {statuses.map(
            (status) => (
              <option
                key={status}
                value={status}
              >
                {status}
              </option>
            ),
          )}

        </select>


        {/* =========================================
            RESET
        ========================================== */}

        {(
          selectedTeam ||
          selectedRiskLevel ||
          selectedStatus ||
          searchTerm
        ) && (

          <button
            type="button"
            onClick={onReset}
            className="
              flex
              h-11
              items-center
              gap-2
              rounded-xl
              border
              border-slate-200
              bg-white
              px-4
              text-sm
              font-medium
              text-slate-600
              transition
              hover:bg-slate-50
              hover:text-slate-800
            "
          >

            <RotateCcw
              size={15}
            />

            Reset

          </button>

        )}

      </div>

    </div>
  );
};


export default AtRiskFilters;